import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useSearchParams, useNavigate } from "react-router-dom";
import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { Alert } from "../components/Alert";
import API from "../service/api";
import { host } from "../service/host";
import { TextInput } from "../components/core/inputs/TextInput";
import { PasswordInput } from "../components/core/inputs/PasswordInput";

export const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const r = searchParams.get('r');

    const [email, setEmail] = useState('');
    const [emailConfirm, setEmailConfirm] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(()=>{
        if (r && r.length > 0) {
            setLoading(true);
            API.POST('/r/reset/get', { id: r }, false)
                .then(res => setEmailConfirm(res.email))
                .catch(err => {
                    console.error(err.message);
                    navigate('..');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
        
    }, [r]);

    const reset = useCallback(async () => {
        try {
            await API.POST('/r/reset', {email}, false);
            setMessage(t('reset_request_success'));
        }catch(err){
            setError(err.message)
        }
    }, [email]);

    const confirmChangePassword = useCallback(async () => {
        try {
            await API.POST('/r/reset/confirm', {id: r, password}, false);
            navigate('../auth?success=1');
        }catch(err){
            setError(err.message)
        }
    }, []);

    return (
        <section className="h-100">
            <div className="container-fluid h-100 ">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="h-100 w-100 col-sm-6 text-black d-flex flex-column justify-content-center align-items-center">
                        <div className="d-flex flex-column flex-fill align-items-center h-custom-2 justify-content-center mb-5 ">
                            <div className="d-flex flex-column align-items-center pt-5 mb-5">
                                <img src={`/logo.png`} style={{width: 128, height: 128}}/>
                                <span className="h2 fw-bold mb-0">{host.getTitle()}</span>
                            </div>

                            <form style={{width: '80vw', maxWidth: '25rem'}}>
                                <h3 className="fw-normal mb-3 pb-3" style={{letterSpacing: "1px"}}>{t('reset_password')}</h3>
                                {loading && <LoadingSpinner/>}

                                {!loading && <>
                                    {emailConfirm && <>
                                        <TextInput label={t('email_address')} icon="envelope" value={emailConfirm} disabled/>
                                        <PasswordInput label={t('password')} icon="key" value={password} onValueChange={setPassword}/>
                                        <PasswordInput label={t('confirmpassword')} icon="key" value={confirmPassword} onValueChange={setConfirmPassword}/>
                                        
                                        <Alert type="danger" message={error}/>
                                        <MDBBtn
                                            block size="lg" color="info" disabled={password !== confirmPassword || password.length < 4} onClick={confirmChangePassword}
                                            className="mt-1 mb-2"
                                        >{t('confirm')}</MDBBtn>
                                    </>}

                                    {!emailConfirm && <>
                                        {!message && <>
                                            <TextInput label={t('email_address')} icon="envelope" value={email} onValueChange={setEmail}/>
                                            <Alert type="danger" message={error}/>
                                            <MDBBtn
                                                block size="lg" color="info" onClick={reset}
                                                className="mt-1 mb-2"
                                            >{t('reset')}</MDBBtn>
                                        </>}
                                        <Alert type="success" message={message}/>
                                    </>}
                                    
                                   
                                </>}
                                <div className='d-flex flex-column justify-content-center align-items-center mt-5'>
                                    <span role="button" className="text-muted">{t('do_you_have_an_account')}</span>
                                    <NavLink to="/auth"><span className="btn btn-link btn-lg btn-block" type="button">{t('login')}</span></NavLink>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}